import { render, staticRenderFns } from "./DecorationItem.vue?vue&type=template&id=4c5cbe10&scoped=true&"
import script from "./DecorationItem.vue?vue&type=script&lang=js&"
export * from "./DecorationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5cbe10",
  null
  
)

export default component.exports